import { LocalizedString } from '@synergy/models';

import { LocalizedContext } from './localized-provider';
import { plainFromMarkup } from './plain-from-markup';

interface LocalizedPlainProps {
    value?: LocalizedString;
}

/**
 * A localized value with its markup taken out, for the places that have one
 * line to say it in. Where there is room, LocalizedHtml renders the same value
 * as it is meant to look.
 */
export const LocalizedPlain = ({ value }: LocalizedPlainProps) => (
    <LocalizedContext.Consumer>
        {context => plainFromMarkup(context.getLocalizedString(value) ?? '')}
    </LocalizedContext.Consumer>
);
